import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0D1B2A] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/14febd11ed764a2e4131edc63c3ba26f/8ff2eb1ab6c7e21da6a0a6b3609c06c8.png" 
                alt="BulkCom Logo" 
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-[#C0C0C0] text-sm leading-relaxed">
              Leading supplier and distributor of natural gas and electricity across international markets.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-[#C0C0C0] hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#C0C0C0] hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#C0C0C0] hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#C0C0C0] hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contactInfo')}</h3>
            <ul className="space-y-3 text-[#C0C0C0] text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-[#2E8BC0] mt-1"></i>
                <div>
                  <div className="font-medium text-white">{t('footer.address')}</div>
                  <div>{t('footer.addressValue')}</div>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-mail-line text-[#2E8BC0] mt-1"></i>
                <div>
                  <div className="font-medium text-white">{t('footer.email')}</div>
                  <a href="mailto:office@bulkcomsro.com" className="hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                    office@bulkcomsro.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-phone-line text-[#2E8BC0] mt-1"></i>
                <div>
                  <div className="font-medium text-white">{t('footer.phone')}</div>
                  <a href="tel:+421123456789" className="hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer">
                    +421 (903) 850-153
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#394B59] text-center text-[#C0C0C0] text-sm">
          <p>© {currentYear} BulkCom. {t('footer.copyright')}</p>
          <p className="mt-2">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#2E8BC0] transition-colors duration-200 cursor-pointer"
            >
              {t('footer.poweredBy')}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
